import { DeviceBrowserCategoriesTable } from "./DeviceBrowserCategoriesTable";

interface DeviceBrowserCategoriesContentProps {
  deviceId: string;
}

export const DeviceBrowserCategoriesContent = ({ deviceId }: DeviceBrowserCategoriesContentProps) => {
  return <DeviceBrowserCategoriesTable deviceId={deviceId} />;
};